import React from "react";

import {
  namePatternMatch,
  emailPatternMatch,
} from "../../../../utilities/helpers";

import { isValidPhoneNumber } from "react-phone-number-input";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";

import { PhoneNumberInput } from "../../../../components/PhoneNumberInput";
import { Error } from "../../../../components/Error";

export default function AssignTo({
  assignTo,
  onAssignToChange,
  isValidEmail,
  setIsValidEmail,
  isValidNumber,
  setIsValidNumber,
}) {
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "email" || value === "" || e.target.validity.valid) {
      onAssignToChange(name, value);
    }
  };

  const handleValidEmail = (e) => {
    if (!emailPatternMatch(e.target.value)) {
      setIsValidEmail(false);
    } else {
      setIsValidEmail(true);
    }
  };

  const handleValidNumber = () => {
    // Since not required -> empty is valid
    if (!assignTo.phoneNumber) {
      setIsValidNumber(true);
      return;
    }

    setIsValidNumber(isValidPhoneNumber(assignTo.phoneNumber));
  };

  return (
    <Stack gap={4}>
      <Row className="m-0">
        <Col className="w-100 px-0">
          <Form.Group className="form-group" controlId="orgName">
            <Form.Label>Organization name (optional)</Form.Label>
            <Form.Control
              type="text"
              name="organizationName"
              placeholder="Enter your organization name"
              value={assignTo?.organizationName || ""}
              onChange={handleChange}
              autoFocus
              autoComplete="none"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="m-0">
        <Col className="ps-0">
          <Form.Group className="form-group" controlId="firstName">
            <Form.Label>First name</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              pattern={namePatternMatch}
              placeholder="Enter your first name"
              value={assignTo?.firstName || ""}
              onChange={handleChange}
              required
              autoComplete="none"
            />
          </Form.Group>
        </Col>
        <Col className="pe-0">
          <Form.Group className="form-group" controlId="lastName">
            <Form.Label>Last name</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              pattern={namePatternMatch}
              placeholder="Enter your last name"
              value={assignTo?.lastName || ""}
              onChange={handleChange}
              required
              autoComplete="none"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="m-0">
        <Col className="ps-0">
          <Form.Group className="form-group" controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={assignTo?.email || ""}
              onChange={handleChange}
              onBlur={handleValidEmail}
              required
              autoComplete="none"
              className={`${!isValidEmail ? "error-border" : ""}`}
            />

            {!isValidEmail && <Error type="invalidEmail" />}
          </Form.Group>
        </Col>
        <Col className="pe-0">
          <Form.Group className="form-group" controlId="lastName">
            <Form.Label>Phone number</Form.Label>
            <PhoneNumberInput
              phoneNumber={assignTo?.phoneNumber}
              setPhoneNumber={(value) => onAssignToChange("phoneNumber", value)}
              isRequired={false}
              onBlur={handleValidNumber}
              hasError={!isValidNumber}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="m-0">
        <Col className="ps-0">
          <Form.Group className="form-group" controlId="deposit">
            <Form.Label>Deposit Amount</Form.Label>
            <Form.Control
              type="number"
              name="deposit"
              placeholder="Enter deposit amount"
              value={assignTo?.deposit || ""}
              onChange={handleChange}
              onBlur={handleValidEmail}
              required
              autoComplete="none"
              className={`${""}`}
            />
          </Form.Group>
        </Col>
        <Col className="pe-0">
          <Form.Group className="form-group" controlId="maxSeatsAllowed">
            <Form.Label>Max Seats allowed to select</Form.Label>
            <Form.Control
              type="number"
              name="maxSeatsAllowed"
              placeholder="Enter max seats allowed"
              value={assignTo?.maxSeatsAllowed || ""}
              onChange={handleChange}
              onBlur={handleValidEmail}
              required
              autoComplete="none"
              className={`${""}`}
            />
          </Form.Group>
        </Col>
      </Row>
      {/* <div>
        <Form.Check
          type="switch"
          id="release-tickets"
          label="Release tickets to buyer"
          checked={canReleaseTickets}
          onChange={(e) => setCanReleaseTickets(e.target.checked)}
          className="form-switch--with-desc"
        />
        <small className="form-switch--with-desc-subtitle subtitle subtitle--dark">
          Enabling this option will grant the buyer access to their tickets
          before completing payment. Ensure this aligns with your payment
          policies before proceeding.
        </small>
      </div> */}
    </Stack>
  );
}
